import * as THREE from 'three'

// -------------------------------------------
// to get a ready to use gradient array from a chroma.js gradient:
// http://gka.github.io/chroma.js/
// -------------------------------------------
//
// let stops = [];
// for(let i = 0; i <= 10; i++){
//	let range = chroma.scale(['yellow', 'navy']).mode('lch').domain([10,0])(i)._rgb
//		.slice(0, 3)
//		.map(v => (v / 255).toFixed(4))
//		.join(", ");
//
//	let line = `[${i / 10}, new THREE.Color(${range})],`;
//
//	stops.push(line);
// }
// stops.join("\n");
//
//
//
// -------------------------------------------
// to get a ready to use gradient array from matplotlib:
// -------------------------------------------
// import matplotlib.pyplot as plt
// import matplotlib.colors as colors
//
// norm = colors.Normalize(vmin=0,vmax=1)
// cmap = plt.cm.viridis
//
// for i in range(0,11):
//	u = i / 10
//	rgb = cmap(norm(u))[0:3]
//	rgb = ["{0:.3f}".format(v) for v in rgb]
//	rgb = "[" + str(u) + ", new THREE.Color(" +  ", ".join(rgb) + ")],"
//	print(rgb)

/** 预置色带集合，每条色带为 [offset, Color] 元组数组 */
const Gradients = {
  // 经典彩虹色带
  RAINBOW: [
    [0, new THREE.Color(0.278, 0, 0.714)],
    [0.07, new THREE.Color(0.139, 0, 0.877)],
    [0.18, new THREE.Color(0, 0, 1)],
    [0.32, new THREE.Color(0, 0.5, 1)],
    [0.46, new THREE.Color(0, 1, 1)],
    [0.61, new THREE.Color(0, 1, 0)],
    [0.75, new THREE.Color(1, 1, 0)],
    [0.88, new THREE.Color(1, 0.64, 0)],
    [1, new THREE.Color(1, 0, 0)],
  ], // 光谱色带：红→橙→黄→绿→蓝
  SPECTRAL: [
    [0, new THREE.Color(1, 0, 0)],
    [0.25, new THREE.Color(1, 0.5, 0)],
    [0.5, new THREE.Color(1, 1, 0)],
    [0.75, new THREE.Color(0, 1, 0)],
    [1, new THREE.Color(0, 0, 1)],
  ],
  // 等离子体色带：紫→粉→黄→橙→红
  PLASMA: [
    [0, new THREE.Color(0.5, 0, 1)],
    [0.25, new THREE.Color(1, 0, 1)],
    [0.5, new THREE.Color(1, 1, 0)],
    [0.75, new THREE.Color(1, 0.5, 0)],
    [1, new THREE.Color(1, 0, 0)],
  ],
  // 黄绿光谱色带：黄→黄绿→绿→青→深蓝
  YELLOW_GREEN: [
    [0, new THREE.Color(1, 1, 0)],
    [0.25, new THREE.Color(0.5, 1, 0)],
    [0.5, new THREE.Color(0, 1, 0)],
    [0.75, new THREE.Color(0, 1, 1)],
    [1, new THREE.Color(0, 0, 0.8)],
  ],
  // 病毒绿色带：绿→蓝绿→蓝→紫蓝→紫
  VIRIDIS: [
    [0, new THREE.Color(0, 1, 0)],
    [0.25, new THREE.Color(0, 0.5, 0.5)],
    [0.5, new THREE.Color(0, 0, 1)],
    [0.75, new THREE.Color(0.25, 0, 0.75)],
    [1, new THREE.Color(0.5, 0, 1)],
  ],
  // Turbo色带：青→浅蓝→粉→橙粉→红
  TURBO: [
    [0, new THREE.Color(0, 1, 1)],
    [0.25, new THREE.Color(0, 0.5, 1)],
    [0.5, new THREE.Color(1, 0, 1)],
    [0.75, new THREE.Color(1, 0.25, 0.75)],
    [1, new THREE.Color(1, 0, 0)],
  ],
  // Inferno色带：黑→深红→橙→黄→白
  INFERNO: [
    [0, new THREE.Color(0, 0, 0)],
    [0.25, new THREE.Color(0.5, 0, 0)],
    [0.5, new THREE.Color(1, 0.5, 0)],
    [0.75, new THREE.Color(1, 0.75, 0)],
    [1, new THREE.Color(1, 1, 1)],
  ],
  // 灰度色带：黑→深灰→灰→浅灰→白
  GRAYSCALE: [
    [0, new THREE.Color(0, 0, 0)],
    [0.25, new THREE.Color(0.25, 0.25, 0.25)],
    [0.5, new THREE.Color(0.5, 0.5, 0.5)],
    [0.75, new THREE.Color(0.75, 0.75, 0.75)],
    [1, new THREE.Color(1, 1, 1)],
  ],
  // 轮廓色带：保持黑白突变
  CONTOUR: [
    [0.0, new THREE.Color(0, 0, 0)],
    [0.03, new THREE.Color(0, 0, 0)],
    [0.04, new THREE.Color(1, 1, 1)],
    [1.0, new THREE.Color(1, 1, 1)],
  ],
} satisfies Record<string, [number, THREE.Color][]>

export { Gradients }
